<div *ngIf="gradientTitle" class="table-header separate {{filterClassName}}">
  <div *ngIf="title" class="title gradient" fxLayoutAlign="start center">
    <span>{{title}}</span>
  </div>

  <app-table-filter [showSearchBtn]="showSearchBtn" *ngIf="filterRowDefs.length" [filterRows]="filterRowDefs">
  </app-table-filter>
</div>

<div class="border shadow responsive-table {{tableClassName}}">
  <div *ngIf="title && !gradientTitle" class="table-header" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="title">
      <span>{{title}}</span>
    </div>
    <div *ngIf="actionBtnConfig?.isDisplayed" class="btn">
      <cm-button (click)="clickActionBtn($event)" [disabled]="actionBtnConfig?.isDisabled"
        [icon]="!actionBtnConfig?.iconType || actionBtnConfig?.iconType == 'mat-icon' ? actionBtnConfig.icon : null"
        [color]="actionBtnConfig?.color">
        <i *ngIf="actionBtnConfig?.iconType == 'icon'" [ngClass]="actionBtnConfig?.icon"></i>
        {{actionBtnConfig?.name}}
      </cm-button>
    </div>
  </div>

  <ng-content select="[breadcrumbs]"></ng-content>

  <table mat-table matSort multiTemplateDataRows [matSortDisableClear]="true" [dataSource]="tableDataSource"
    (matSortChange)="sortTable($event)" [matSortDirection]="sortOrder" [matSortActive]="sortBy">


    <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.name">

      <ng-container *ngIf="tableColumn.isSortable; else notSortable">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="tableColumn.name" [style.width]="tableColumn.width"
          [arrowPosition]="tableColumn.position === 'right' ? 'before' : 'after'" [ngClass]="tableColumn.className">
          <ng-container *ngIf="!tableColumn.hideHeader">
            {{ tableColumn.name }}<span *ngIf="tableColumn.required" class="required-asterisk">*</span><span *ngIf="tableColumn.headerTooltip" class="header-tooltip-icon" [matTooltip]="tableColumn.headerTooltip" matTooltipPosition="above">?</span>
          </ng-container>
        </th>
      </ng-container>

      <ng-template #notSortable>
        <th mat-header-cell *matHeaderCellDef [style.width]="tableColumn.width"
          [class.text-right]="tableColumn.position == 'right'" [ngClass]="tableColumn.className">
          <ng-container *ngIf="!tableColumn.hideHeader">
            {{ tableColumn.name }}<span *ngIf="tableColumn.required" class="required-asterisk">*</span><span *ngIf="tableColumn.headerTooltip" class="header-tooltip-icon" [matTooltip]="tableColumn.headerTooltip" matTooltipPosition="above">?</span>
          </ng-container>
        </th>
      </ng-template>

      <td mat-cell *matCellDef="let element" [class.text-right]="tableColumn.position == 'right'"
        [style.width]="tableColumn.width" [ngClass]="tableColumn.className">
        <ng-container [ngSwitch]="tableColumn.templateName">
          <ng-container *ngSwitchCase="'checkbox'">
            <mat-checkbox (click)="$event.stopPropagation(); selectCheckbox(element)"
              [disabled]="element.isDisabled || element.required" [(ngModel)]="element.checked" name="{{element.id}}">
            </mat-checkbox>
          </ng-container>
          <ng-container *ngSwitchCase="'term-checkbox'">
            <mat-checkbox
  [(ngModel)]="element[tableColumn.dataKey]"
  (click)="$event.stopPropagation()"
  (change)="onCheckboxChange(element)"
  [disabled]="tableColumn.disabled || element['disable' + tableColumn.dataKey.charAt(0).toUpperCase() + tableColumn.dataKey.slice(1)]">
</mat-checkbox>
          </ng-container>
          <ng-container *ngSwitchCase="'input-box'">
            <mat-form-field appearance="outline" class="input-box-field"
              [class.field-invalid]="getRowInvalidFields && getRowInvalidFields(element)?.includes(tableColumn.dataKey)">
              <input matInput type="text" [(ngModel)]="element[tableColumn.dataKey]"
                placeholder="{{ tableColumn.placeholder || tableColumn.name }}" (click)="$event.stopPropagation()"
                (keydown)="onInputBoxKeydown($event, tableColumn)"
                (input)="onInputBoxInput($event, tableColumn)"
                (blur)="onInputChange(element, tableColumn)"
                [disabled]="tableColumn.disabled || element['disable' + tableColumn.dataKey.charAt(0).toUpperCase() + tableColumn.dataKey.slice(1)]" />
            </mat-form-field>
          </ng-container>

          <!-- Input + Dropdown for Duration -->
          <ng-container *ngSwitchCase="'input-select'">
            <div class="duration-cell" >
              <mat-form-field appearance="outline" class="duration-input"
                [class.field-invalid]="getRowInvalidFields && getRowInvalidFields(element)?.includes('durationValue')">
                <input matInput type="number" min="0" [(ngModel)]="element.durationValue" placeholder="Value"
                  (click)="$event.stopPropagation()" (ngModelChange)="onInputSelectChange(element, tableColumn)"
                  [disabled]="tableColumn.disabled || element.disableDurationValue" />
              </mat-form-field>
          
              <mat-form-field appearance="outline" class="duration-select"
                [class.field-invalid]="getRowInvalidFields && getRowInvalidFields(element)?.includes('durationUnit')">
                <mat-select [(ngModel)]="element.durationUnit" (click)="$event.stopPropagation()"
                  (selectionChange)="onInputSelectChange(element, tableColumn)"
                  [disabled]="tableColumn.disabled || element.disableDurationUnit">
                  <mat-option value="Days">Days</mat-option>
                  <mat-option value="Weeks">Weeks</mat-option>
                  <mat-option value="Months">Months</mat-option>
                  <mat-option value="Years">Years</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'priority'">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div [ngClass]="element | dataPropertyGetter: tableColumn.dataKey" class="priority-icon"></div>
              <span *ngIf="show"> {{element | dataPropertyGetter: tableColumn.dataKey}} </span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'description'">
            <div class="description-column-main">
              <div class="clamped-text">
                {{element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async}}
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'notesDescription'">
            <div class="notes-description-container">
              <div class="notes-text" [innerHTML]="getTruncatedText(element, tableColumn.dataKey)">
              </div>
              <span *ngIf="shouldShowReadMore(element, tableColumn.dataKey)" class="read-more-link"
                (click)="onReadMoreClick(element, $event)">
                ...read more
              </span>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'narrativeCodesList'">
            <ul>
              <li *ngFor="let n of (element | dataPropertyGetter: tableColumn.dataKey) || []">
                {{ n?.description }}
              </li>
            </ul>
          </ng-container>
          <ng-container *ngSwitchCase="'tooltip'">
            <div class="description-column">
              <div [clamp]="3" matTooltipPosition="above"
                matTooltip="{{element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async}}">
                {{element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async }}
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'productDynamicTooltip'">
            <div class="description-column"
              [ngClass]="(element | dataPropertyGetter: tableColumn.dataKey) === 'Product' ? 'product-dynamic-tooltip' : '' ">
              <div [clamp]="3" matTooltipPosition="above"
                [matTooltip]="(element | dataPropertyGetter: tableColumn.dataKey) === 'Product' ? 
                (element | dataPropertyGetter: tableColumn.tooltipDataValue | dynamicPipe: tableColumn.pipe | async) : ''">
                {{element | dataPropertyGetter: tableColumn.dataKey }}
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'file'">
            <div class="file-column">
              <span *ngIf="element.isFile"><i class="icon icon-file"></i></span>
              <span *ngIf="!element.isFile"><i class="icon icon-folder"></i></span>
              {{element | dataPropertyGetter: tableColumn.dataKey}}
              <span *ngIf="element.required"><i class="icon icon-lock"></i></span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'conversationType'">
            <ng-container [ngSwitch]="element | dataPropertyGetter: tableColumn.dataKey">
              <ng-container *ngSwitchCase="conversationType.opportunity"><i class="icon icon-star"></i></ng-container>
              <ng-container *ngSwitchCase="conversationType.conversation"><i class="icon icon-conversation"></i>
              </ng-container>
              <ng-container *ngSwitchCase="conversationType.concern"><i class="icon icon-alert"></i></ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'createdByOrAssignee'">
            {{ getFullName(element | dataPropertyGetter: tableColumn.dataKey) || '' }}
          </ng-container>
          <ng-container *ngSwitchCase="'link'">
            <a>{{element | dataPropertyGetter: tableColumn.dataKey}}</a>
          </ng-container>
          <ng-container *ngSwitchCase="'chips'">
            <mat-chip-list>
              <mat-chip
                *ngFor="let chip of element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async">
                {{chip}}
              </mat-chip>
            </mat-chip-list>
          </ng-container>

          <!-- <ng-container *ngSwitchCase="'oldValueTemplate'">
            <ng-container *ngIf="hasFiveWords(element.oldValue); else showOldValue">
          
              <cm-button color="primary" size="small-button" (click)=" element._showOldModal=true">
                Show
              </cm-button>
            
              <div class="modal-overlay" *ngIf="element._showOldModal">
                <div class="modal-box">
                  <h3>Old Value</h3>
                  <p>{{ element.oldValue }}</p>
                  <cm-button color="secondary" (click)="element._showOldModal = false">Close</cm-button>
          
                </div>
              </div>
            </ng-container>
            <ng-template #showOldValue>
              <span>{{ element | dataPropertyGetter: tableColumn.dataKey }}</span>
            </ng-template>
          </ng-container> -->
          <ng-container *ngSwitchCase="'valueModalTemplate'">
            <ng-container *ngIf="hasFiveWords(element[tableColumn.dataKey]); else showFullValue">
              <cm-button color="primary" size="small-button" (click)="openModal(element, tableColumn.dataKey)">
                Show
              </cm-button>

              <!-- Modal Overlay -->
              <div class="modal-overlay" *ngIf="isModalVisible(element, tableColumn.dataKey)">
                <div class="modal-box">
                  <h3>{{ tableColumn.name }}</h3>
                  <p class="modal-content">{{ element[tableColumn.dataKey] }}</p>
                  <cm-button color="secondary" (click)="closeModal(element, tableColumn.dataKey)">Close</cm-button>
                </div>
              </div>
            </ng-container>

            <ng-template #showFullValue>
              <span>{{ element | dataPropertyGetter: tableColumn.dataKey }}</span>
            </ng-template>
          </ng-container>


          <ng-container *ngSwitchCase="'region'">
            <span (click)="expandedElement = expandedElement === element ? null : element; isExpanded = true"
              *ngIf="element[tableColumn.externalKey]?.length">
              <span class="icon-container">
                <i *ngIf="!expandedElement" class="action-icon icon-arrow_down"></i>
                <i *ngIf="expandedElement" class="action-icon icon-arrow_up"></i>
                {{element | dataPropertyGetter: tableColumn.dataKey}}
              </span>
            </span>
            <span *ngIf="!element[tableColumn.externalKey]?.length">
              {{element | dataPropertyGetter: tableColumn.dataKey}}
            </span>
          </ng-container>

          <ng-container *ngSwitchCase="'import'">
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
              <span *ngIf="element.isImported"
                class="icon-{{element | dataPropertyGetter: tableColumn.dataKey}}"></span>
              <span (click)="$event.stopPropagation(); startImport(element)" class="icon-import"></span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'import-offer-delete'">
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
              <span *ngIf="!element.imported && element.isReadyForImport()"
                (click)="$event.stopPropagation(); startImport(element)" class="icon-upload"></span>
              <span (click)="$event.stopPropagation(); download(element)" class="icon-import"></span>
              <span *ngIf="!element.isImportInProcess()" (click)="$event.stopPropagation(); delete(element)"
                class="icon-trash"></span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'import-delete'">
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
              <ng-container *ngIf="element.importType === 'Manual'">
                <span *ngIf="!element.imported && element.isReadyForImport()"
                  (click)="$event.stopPropagation(); startImport(element)" class="icon-upload"></span>
                <span (click)="$event.stopPropagation(); download(element)" class="icon-import"></span>
              </ng-container>

              <ng-container
                *ngIf="element.importType === 'Opportunity Engine' || element.importType === 'Scheduled Opportunity Engine'">
                <span *ngIf="element.conversationImportStatus === 'Pending'">
                  <img class="import-loader" src="assets/images/loader.gif">
                </span>
                <span *ngIf="element.conversationImportStatus === 'Processed'"
                  (click)="$event.stopPropagation(); download(element)" class="icon-import"></span>
              </ng-container>
              <span *ngIf="!element.isImportInProcess()" (click)="$event.stopPropagation(); delete(element)"
                class="icon-trash"></span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'combined'">
            {{ element.creditor?.name || '' }}<br>
            #: {{ element.creditor?.customerNumber || '' }}<br>
            <span *ngIf="element?.accountNumber">Account: {{ element.accountNumber }}<br></span>
            Narrative:
            <ul>
              <li *ngFor="let narrative of (element.narratives || element.creditor?.narratives || [])">
                {{ narrative?.description }}
              </li>
            </ul>

          </ng-container>
          <ng-container *ngSwitchCase="'combinedDays'">
            {{ element?.historyDerogatoryCount30DayPastDue != null ? element.historyDerogatoryCount30DayPastDue: 'NA'
            }}/{{
            element?.historyDerogatoryCount60DayPastDue != null ? element.historyDerogatoryCount60DayPastDue: 'NA' }}
            /{{element?.historyDerogatoryCount90DayPastDue !=null ? element.historyDerogatoryCount90DayPastDue: 'NA'
            }}

          </ng-container>
          <ng-container *ngSwitchCase="'court-number'">
            {{element.court.customerNumber}}
          </ng-container>
          <ng-container *ngSwitchCase="'court-name'">
            {{element.court.name}}
          </ng-container>
          <!-- <ng-container *ngSwitchCase="'view-download'">
            <div fxLayout="row" fxLayoutGap="5px">
              <span (click)="$event.stopPropagation(); view(element)" class="view-download-import">View</span>
              <span>|</span>
              <span (click)="$event.stopPropagation(); download(element)" class="view-download-import">Download</span>
            </div>
          </ng-container> -->
          <ng-container *ngSwitchCase="'credit-report-btns'">
            <app-three-dots-menu color="primary" (click)="$event.stopPropagation()">
              <ng-container menu>

                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="view(element)">
                  <i class="icon-edit"></i>
                  <span>View</span>
                </button>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="downloadPDF(element)">
                  <i class="icon-import"></i>
                  <span>Download as PDF</span>
                </button>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="downloadXML(element)">
                  <i class="icon-import"></i>
                  <span>Download as XML</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>
          <ng-container *ngSwitchCase="'credit-report-btns-equifax-us'">
            <app-three-dots-menu color="primary" (click)="$event.stopPropagation()">
              <ng-container menu>

                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="view(element)">
                  <i class="icon-edit"></i>
                  <span>View</span>
                </button>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="downloadPDF(element)">
                  <i class="icon-import"></i>
                  <span>Download as PDF</span>
                </button>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="downloadJSON(element)">
                  <i class="icon-import"></i>
                  <span>Download as JSON</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>

          <ng-container *ngSwitchCase="'category-management-btns'">
            <app-three-dots-menu color="primary" (click)="$event.stopPropagation()">
              <ng-container menu>
                <!-- <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="view(element)">
                  <i class="icon-view"></i>
                  <span>View</span>
                </button> -->
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px"
                  (click)="$event.stopPropagation();  edit(element, $event)">
                  <i class="icon-edit"></i>
                  <span>Edit</span>
                </button>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="products(element)">
                  <i class="icon-product"></i>
                  <span>Show Product</span>
                </button>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px"
                  (click)="viewChangeLog(element)">
                  <i class="icon-read"></i>
                  <span>View Change Log</span>
                </button>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="delete(element)"
                  [disabled]="element.hasProducts">
                  <i class="icon-trash"></i>
                  <span>Delete</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>

          <ng-container *ngSwitchCase="'product-link'">
            <ng-container *ngIf="element.productCount > 0; else noProducts">
              <a class="clickable-column product-link" (click)="products(element)"
                [matTooltip]="getProductTooltip(element)" matTooltipPosition="above" matTooltipClass="product-tooltip">
                Product
              </a>
            </ng-container>
            <ng-template #noProducts>
              <span class="no-products">NA</span>
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="'product-management-btns'">
            <app-three-dots-menu color="primary" (click)="$event.stopPropagation()">
              <ng-container menu>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="view(element)">
                  <i class="icon-view"></i>
                  <span>View</span>
                </button>
                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="delete(element)"
                  [disabled]="element.isApplicationMapped">
                  <i class="icon-trash"></i>
                  <span>Delete</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>

          <!-- <ng-container *ngSwitchCase="'selectBtn'">
            <cm-button mat-raised-button color="secondary" (click)="onSelectRow(element, $event)">
              Select
            </cm-button>
          </ng-container> -->

          <ng-container *ngSwitchCase="'rank-btns'">
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px" (click)="$event.stopPropagation()">
              <!-- Disable UP if this is the smallest rank or field is disabled -->
              <span (click)="!element.disableOrder && element.rank > minRank && moveCategoryRankUp(element)"
                [class.disabled]="element.rank === minRank || element.disableOrder" class="icon-arrow_up rank-actions">
              </span>

              <!-- Disable DOWN if this is the largest rank or field is disabled -->
              <span (click)="!element.disableOrder && element.rank < maxRank && moveCategoryRankDown(element)"
                [class.disabled]="element.rank === maxRank || element.disableOrder" class="icon-arrow_down rank-actions">
              </span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'only-edit'">
            <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5px">
              <span (click)="$event.stopPropagation(); edit(element, $event)" class="icon-edit"
                [class.disabled]="!hasContentEditPermission">
              </span>
            </div>
          </ng-container>


          <ng-container *ngSwitchCase="'view-btns'">
            <app-three-dots-menu color="primary" (click)="$event.stopPropagation()">
              <ng-container menu>

                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="view(element)">
                  <i class="icon-edit"></i>
                  <span>View</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>
          <ng-container *ngSwitchCase="'resume-view'">
            <app-three-dots-menu color="primary" (click)="$event.stopPropagation()"
              *ngIf="element.status === 'InProgress' && isRetailBranchApplication">
              <ng-container menu>


                <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px" (click)="view(element)">
                  <i class="icon-edit"></i>
                  <span>Resume</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>
          <ng-container *ngSwitchCase="'edit-delete'">
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
              <span (click)="$event.stopPropagation(); edit(element, $event)" class="icon-edit"></span>
              <span (click)="$event.stopPropagation(); delete(element)" class="icon-trash "></span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'delete'">
            <span *ngIf="!element.disableDelete" (click)="$event.stopPropagation(); delete(element)" class="icon-trash"></span>
            <span *ngIf="element.disableDelete"  (click)="$event.stopPropagation()" class="icon-trash disabled" matTooltip="Delete is not available"></span>
          </ng-container>
          <ng-container *ngSwitchCase="'edit'">
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
              <ng-container *ngIf="!tableColumn.hide">
                <span (click)="$event.stopPropagation();  edit(element, $event)" class="icon-edit"></span>
              </ng-container>
              <ng-container *ngIf="tableColumn.isCopyURL">
                <span mat-icon-button class="icon-copy copy-icon-allignment" matTooltip="Copy Link"
                  (click)="copyPromoUrl(getPromoUrl(element), $event)">
                  <mat-icon>content_copy</mat-icon>
                </span>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'icontick'" class="wrapper">
            <span class="circle" *ngIf="element.primaryIcon">
              <span class="checkMark"></span>
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'deleteTrash'">
            <span *ngIf="element.trashIcon" (click)="$event.stopPropagation(); delete(element)" class="icon-trash">
            </span>
          </ng-container>

          <ng-container *ngSwitchCase="'sendactivation'">
            <span *ngIf="element.isReadyForActivation()" (click)="$event.stopPropagation(); sendactivation(element)"
              class="icon-upload">
              Send Activation
            </span>

            <span *ngIf="element.isReadyForReset()" (click)="$event.stopPropagation(); resetpassword(element)"
              class="reset-password-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 2v6h-6"></path>
                <path d="M3 12a9 9 0 0 1 15-6.7l3 3"></path>
                <path d="M3 22v-6h6"></path>
                <path d="M21 12a9 9 0 0 1-15 6.7l-3-3"></path>
              </svg>
              Reset Password
            </span>

          </ng-container>
          <ng-container *ngSwitchCase="'clickableColumn'">
            <ng-container *ngIf="hasPermissionForRedirection(); else plainText">
              <a class="clickable-column" [href]="tableColumn.getLinkUrl(element)" fxLayoutAlign="space-between">
                {{element | dataPropertyGetter: tableColumn.dataKey}}
              </a>
            </ng-container>
            <ng-template #plainText>
              {{element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async}}
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'clickableColumnExternal'">
            <ng-container *ngIf="hasPermissionForRedirection(); else plainText">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px"
                style="max-width: 300px; overflow: hidden; white-space: nowrap;">
                <a class="clickable-column" [href]="tableColumn.getLinkUrl(element)" target="_blank"
                  rel="noopener noreferrer" fxLayoutAlign="space-between">
                  {{element | dataPropertyGetter: tableColumn.dataKey}}
                </a>

              </div>
            </ng-container>
            <ng-template #plainText>
              {{element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async}}
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="'name'" [matColumnDef]="column.columnDef">
            <ng-container
              *ngTemplateOutlet="nameTemplate; context: {$implicit: element, column: column}"></ng-container>
            <ng-template #nameTemplate let-element let-column="column">
              <span>{{ element.firstName }} {{ element.lastName }}</span>
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="'clickableCol'">
            <a class="clickable-column" (click)="clickedColumn(element)" fxLayoutAlign="space-between">
              {{ element | dataPropertyGetter: tableColumn.dataKey }}
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="'clickableColApplicationUsage'">
            <ng-container *ngIf="hasPermissionForRedirection(); else plainText">
              <a class="clickable-column" [href]="tableColumn.getLinkUrl(element)" fxLayoutAlign="space-between">
                {{ element | dataPropertyGetter: tableColumn.dataKey }}
              </a>
            </ng-container>
            <ng-template #plainText>
              {{element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async}}
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'datetime'">
            <div class="date-column" [ngClass]="isOverdue(element)">
              <!-- {{element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async }} -->
              {{element | dataPropertyGetter: tableColumn.dataKey | formatDateMMDDYYYY }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'dateTime12Hour'">
            {{element | dataPropertyGetter: tableColumn.dataKey | date:'dd-MM-yyyy hh:mm a'}}
          </ng-container>
          <ng-container *ngSwitchCase="'formatDateTime'">
            <div class="date-column" [ngClass]="isOverdue(element)">
              {{element | dataPropertyGetter: tableColumn.dataKey | date:'MM, dd, YYYY HH:mm'}}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'percent'">
            <div class="description-column">
              {{element | dataPropertyGetter: tableColumn.dataKey | number: '.2-2'}}%
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'member'">
            <app-member-list [ngClass]="tableColumn.className" *ngIf="!element.isLinkHidden"
              [readOnly]="tableColumn.areActionsReadOnly"
              [linksList]="element | dataPropertyGetter: tableColumn.dataKey"
              [memberProfile]="element | dataPropertyGetter: tableColumn.dataKey"></app-member-list>
          </ng-container>
          <!--          TODO: this template (actionBtn) is kept for future-->
          <ng-container *ngSwitchCase="'actionBtn'">
            <div *ngIf="show && isColumnVisible(tableColumn)">
              <i class="icon-trash btn" (click)="delete(element)"></i>
              <i class="icon-edit btn" (click)="edit(element, $event)"></i>
            </div>
            <div *ngIf="!show && isColumnVisible(tableColumn)">
              <app-three-dots-menu color="primary" (click)="$event.stopPropagation()">
                <ng-container menu>
                  <button class="mat-menu-item  table-btn-delete" mat-menu-item fxLayout fxLayoutGap="10px"
                    (click)="delete(element)">
                    <i class="icon-trash"></i>
                    <span>Delete</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px"
                    (click)="edit(element, $event)">
                    <i class="icon-edit"></i>
                    <span>Edit</span>
                  </button>
                </ng-container>
              </app-three-dots-menu>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'ecm-btns'">
            <app-three-dots-menu color="primary" *ngIf="!element.isDisabled || element.isAdmin"
              (click)="$event.stopPropagation()">
              <ng-container menu>
                <button *ngIf="element.isFile" class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px"
                  (click)="download(element)">
                  <i class="icon-import"></i>
                  <span>Download</span>
                </button>
                <button *ngIf="!element.isArchived" class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px"
                  (click)="edit(element, $event)">
                  <i class="icon-edit"></i>
                  <span>Edit</span>
                </button>
                <button *ngIf="!element.isArchived && element.isFile" class="mat-menu-item table-btn-delete"
                  mat-menu-item [disabled]="element.required || !element.hasAccess" fxLayout fxLayoutGap="10px"
                  (click)="archive(element)">
                  <i class="icon-upload"></i>
                  <span>Archive</span>
                </button>
                <button *ngIf="element.isArchived" class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px"
                  (click)="restore(element)">
                  <img class="restore-icon" src="assets/icons/restore-icon.svg" />
                  <span>Restore</span>
                </button>
                <button class="mat-menu-item table-btn-delete"
                  [disabled]=" !isDeletionPermission || element.required || !element.hasAccess" fxLayout mat-menu-item
                  fxLayoutGap="10px" (click)="delete(element)">
                  <i class="icon-trash"></i>
                  <span>Delete</span>
                </button>

              </ng-container>
            </app-three-dots-menu>
          </ng-container>

          <ng-container *ngSwitchCase="'documentActionBtn'">
            <button mat-icon-button [matMenuTriggerFor]="mainMenu">
              <mat-icon>more_vert</mat-icon>
            </button>

            <!-- Main menu -->
            <mat-menu #mainMenu="matMenu">
              <button mat-menu-item [matMenuTriggerFor]="previewMenu">
                <i class="icon-view"></i>
                <span>Preview</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="downloadMenu">
                <i class="icon-import"></i>
                <span>Download</span>
              </button>
            </mat-menu>

            <!-- Preview submenu - Dynamic based on noOfSignersSupported -->
            <mat-menu #previewMenu="matMenu">
              <button *ngFor="let signer of [].constructor(element.noOfSignersSupported); let i = index" mat-menu-item
                (click)="onPreviewClick(element, (i + 1).toString())">
                Signer {{ i + 1 }}
              </button>
            </mat-menu>

            <!-- Download submenu -->
            <mat-menu #downloadMenu="matMenu">
              <button *ngFor="let signer of [].constructor(element.noOfSignersSupported); let i = index" mat-menu-item
                (click)="onDownloadClick(element, i)">
                Signer {{ i + 1 }}
              </button>
            </mat-menu>
          </ng-container>

          <ng-container *ngSwitchCase="'applicantDocumentActionBtn'">
            <button mat-icon-button [matMenuTriggerFor]="mainMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #mainMenu="matMenu">
              <button mat-menu-item (click)="onDownloadClick(element, null)" [disabled]="!element.isActionDisabled"
                [matTooltip]="!element.isActionDisabled ? 'Document must be signed by all parties' : ''">
                <span>Download</span>
              </button>
              <button mat-menu-item (click)="onPreviewClick(element, null)" [disabled]="!element.isActionDisabled"
                [matTooltip]="!element.isActionDisabled ? 'Document must be signed by all parties' : ''">
                <span>Preview</span>
              </button>
              <button mat-menu-item [disabled]="!element.isSigningDisabled"
                (click)="onSignDocumentClick(element, null)">
                <span>Sign Document</span>
              </button>
            </mat-menu>
          </ng-container>



          <ng-container *ngSwitchCase="'signerList'">
            <ng-container *ngIf="element.noOfSignersSupported as count">
              <div class="mb-20" *ngFor="let i of [].constructor(count); let idx = index">
                Signer {{ idx + 1 }}
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'documentApplicants'">
            <div *ngFor="let dropdown of [].constructor(element.noOfSignersSupported); let i = index">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-select [(ngModel)]="element.selectedApplicants[i]" placeholder="Select Applicant">
                  <mat-option *ngFor="let applicant of (getAvailableOptionsFn ? getAvailableOptionsFn(element, i) : [])"
                    [value]="applicant">
                    {{ applicant.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'documentProducts'">
            <div *ngFor="let dropdown of [].constructor(element.noOfProductsSupported); let i = index">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-select [(ngModel)]="element.selectedProducts[i]" placeholder="Select Product">
                  <mat-option
                    *ngFor="let product of (getAvailableProductOptionsFn ? getAvailableProductOptionsFn(element, i) : [])"
                    [value]="product">
                    {{ product.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'edit_delete'">
            <app-three-dots-menu class="edit-delete-menu" color="primary" *ngIf="!element.isDisabled || element.isAdmin"
              (click)="$event.stopPropagation()">
              <ng-container menu>
                <button class="mat-menu-item table-btn-edit" mat-menu-item fxLayout fxLayoutGap="10px"
                  (click)="edit(element, $event)">
                  <i class="icon-edit"></i>
                  <span>Edit</span>
                </button>
                <button class="mat-menu-item table-btn-delete" fxLayout mat-menu-item fxLayoutGap="10px"
                  (click)="delete(element)">
                  <i class="icon-trash"></i>
                  <span>Delete</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>

          <ng-container *ngSwitchCase="'member-btn'">
            <app-three-dots-menu color="primary" *ngIf="!element.isDisabled || element.isAdmin"
              (click)="$event.stopPropagation()">
              <ng-container menu>
                <button *ngIf="element.isFile" class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px"
                  (click)="download(element)">
                  <i class="icon-import"></i>
                  <span>Download</span>
                </button>
                <button *ngIf="element.isMemberDocument" class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px"
                  (click)="edit(element, $event)">
                  <i class="icon-edit"></i>
                  <span>Edit</span>
                </button>
                <!-- <button *ngIf="!element.isArchived && element.isFile"
                class="mat-menu-item table-btn-delete" 
                mat-menu-item
                [disabled]="element.required || !element.hasAccess"
                fxLayout
                fxLayoutGap="10px"
                (click)="archive(element)">
          <i class="icon-upload"></i>
          <span>Archive</span> -->
                <!-- </button>
                <button *ngIf="element.isArchived"
                class="mat-menu-item"
                mat-menu-item
                fxLayout
                fxLayoutGap="10px"
                (click)="restore(element)">
          <i class="icon-edit"></i>
          <span>Restore</span>
        </button> -->
                <button *ngIf="element.isMemberDocument" class="mat-menu-item table-btn-delete" fxLayout mat-menu-item
                  fxLayoutGap="10px" (click)="delete(element)">
                  <i class="icon-trash"></i>
                  <span>Delete</span>
                </button>

              </ng-container>
            </app-three-dots-menu>
          </ng-container>
          <ng-container *ngSwitchCase="'download'">
            <app-three-dots-menu (click)="$event.stopPropagation()" *ngIf="!element.isDisabled" color="primary">
              <ng-container menu>
                <button (click)="download(element)" class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px">
                  <i class="icon-import"></i>
                  <span>Download</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>
          <ng-container *ngSwitchCase="'attachment'">
            <i class="icon-attachment" *ngIf="(element | dataPropertyGetter: tableColumn.dataKey).length"></i>
          </ng-container>
          <ng-container *ngSwitchCase="'currency'">
            {{element | dataPropertyGetter: tableColumn.dataKey | currency :'USD' : 'symbol' : '1.2-2' | dynamicPipe:
            tableColumn.pipe : element | async }}
          </ng-container>
          <ng-container *ngSwitchCase="'_currency'">
            <ng-container *ngIf="(element | dataPropertyGetter: tableColumn.dataKey) === 'N/A'">
              N/A
            </ng-container>
            <ng-container *ngIf="(element | dataPropertyGetter: tableColumn.dataKey) !== 'N/A'">
              {{element | dataPropertyGetter: tableColumn.dataKey | currency :'USD' : 'symbol' : '1.2-2' | dynamicPipe:
              tableColumn.pipe | async }}
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'summary'">
            <span [innerHTML]="element.summary"></span>
          </ng-container>
          <ng-container *ngSwitchCase="'liability-details'">
            <div class="details-column" 
                 [innerHTML]="sanitizeHtmlPreserveLineBreaks(element[tableColumn.dataKey], element)"
                 (click)="handleDetailsLinkClick($event)">
                 
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'oldValue'">
            <ng-container *ngIf="shouldShowViewDetails(element, 'oldValue'); else showOldValuePlain">
              <div class="change-log-value-container">
                <span class="change-log-text">{{ getTruncatedPlainText(element, 'oldValue') }}</span>
                <a class="view-details-link" 
                   [matTooltip]="getPlainTextValue(element, 'oldValue')" 
                   matTooltipPosition="above"
                   matTooltipClass="change-log-tooltip"
                   (click)="$event.stopPropagation()">
                  View Details
                </a>
              </div>
            </ng-container>
            <ng-template #showOldValuePlain>
              <span>{{ getPlainTextValue(element, 'oldValue') }}</span>
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'newValue'">
            <ng-container *ngIf="shouldShowViewDetails(element, 'newValue'); else showNewValuePlain">
              <div class="change-log-value-container">
                <span class="change-log-text">{{ getTruncatedPlainText(element, 'newValue') }}</span>
                <a class="view-details-link" 
                   [matTooltip]="getPlainTextValue(element, 'newValue')" 
                   matTooltipPosition="above"
                   matTooltipClass="change-log-tooltip"
                   (click)="$event.stopPropagation()">
                  View Details
                </a>
              </div>
            </ng-container>
            <ng-template #showNewValuePlain>
              <span>{{ getPlainTextValue(element, 'newValue') }}</span>
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'skipRescedule'">
            <a class="clickable-column" [class.skipdisabled]="!hasSchedulingPermission"
              (click)="skipRescheduleBtn(element)">{{element.actions}}</a>
          </ng-container>
          <ng-container *ngSwitchCase="'dateTime'">
            {{element | dataPropertyGetter: tableColumn.dataKey | date:'dd-MM-yyyy HH:mm ' | dynamicPipe:
            tableColumn.pipe : '(EST)' | async}}
          </ng-container>
          <ng-container *ngSwitchCase="'LendingOrChequeFlag'">
            <ng-container [ngSwitch]="element[tableColumn.dataKey]">
              <span *ngSwitchCase="1"><mat-icon class="lending-icon">attach_money</mat-icon></span>
              <span *ngSwitchCase="2"><mat-icon class="cheque-icon">credit_card</mat-icon></span>
              <span *ngSwitchCase="3"><mat-icon class="lending-icon">attach_money</mat-icon></span>
              <!-- nothing for case 4 or undefined -->
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'textValue'">
            {{ getCellValue(element, tableColumn.dataKey) }}
          </ng-container>
          <ng-container *ngSwitchCase="'source-with-date'">
            <div class="source-date-column">
              <div>{{element | dataPropertyGetter: tableColumn.dataKey}}</div>
              <div class="date-text">{{formatSourceDate(element.createdDate)}}</div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'download_delete'">
            <app-three-dots-menu (click)="$event.stopPropagation()" *ngIf="!element.isDisabled" color="primary">
              <ng-container menu>
                <button (click)="download(element)" class="mat-menu-item" mat-menu-item fxLayout fxLayoutGap="10px">
                  <i class="icon-import"></i>
                  <span>Download</span>
                </button>
                <button *ngIf="!disableEditing && element.uploadedBy === 'Staff'" class="mat-menu-item table-btn-delete"
                  fxLayout mat-menu-item fxLayoutGap="10px" (click)="delete(element)">
                  <i class="icon-trash"></i>
                  <span>Delete</span>
                </button>
              </ng-container>
            </app-three-dots-menu>
          </ng-container>
          <ng-container *ngSwitchCase="'boolean'">
            <span>
              {{ (element | dataPropertyGetter: tableColumn.dataKey) ? 'Yes' : 'No' }}
            </span>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{element | dataPropertyGetter: tableColumn.dataKey | dynamicPipe: tableColumn.pipe | async}}
          </ng-container>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedAccordion">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns?.length">
        <div class="accordion-element-detail">
          <app-region-builder *ngIf="isExpanded" [tableConfig]="tableColumns" (clickAction)="accordionClick($event)"
            [data]="element.data">
          </app-region-builder>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row [class.parent-row]="expandedElement === row" *matRowDef="let row; columns: displayedColumns;"
      (click)="clickRow(row)" [class.disabled]="row.isDisabled"
      [ngClass]="[isClickable() ? 'pointer' : '', row?.rowClass || '']"></tr>

    <tr *matNoDataRow>
      <td class="emptyMsg" [colSpan]="tableColumns?.length">{{emptyMsg}}</td>
    </tr>

    <tr mat-row [class.full-expanded-row]="expandedElement === row" *matRowDef="let row; columns: ['expandedAccordion']"
      class="accordion-row"></tr>

  </table>

  <mat-paginator *ngIf="isPageable && tableDataSource.data.length" [length]="totalCount" [pageIndex]="page"
    [pageSizeOptions]="paginationSizes" [pageSize]="defaultPageSize" (page)="pageChange($event)" showFirstLastButtons>
  </mat-paginator>

  <div class="footer" *ngIf="footerTemplate">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </div>

</div>